import classNames from "classnames";
import { FunctionComponent } from "react";
import { profileListHref } from "../../constants/profile-links";
import useSize from "../../hooks/useSize";
import { Balances } from "./components/Balances";
import { FloatingHeader } from "./floating-header";
import "./header.css";

export interface HeaderProps {
  showFloatingHeader: boolean;
  SearchComponent: FunctionComponent<any>;
  LoginComponent: FunctionComponent<any>;
  isMunicipalityHome?: boolean;
  municipioQuerySuffix?: string;
}
export const Header = ({
  SearchComponent,
  showFloatingHeader,
  LoginComponent,
  isMunicipalityHome = false,
  municipioQuerySuffix = "",
}: HeaderProps) => {
  const mainClassName = classNames({
    "xvia-catalog-header": true,
    "xvia-catalog-header--fixed": showFloatingHeader,
    "xvia-catalog-header--visible": !showFloatingHeader,
  });
  const { width } = useSize();

  return (
    <div className={mainClassName}>
      <div className="xvia-catalog-header__container">
        <FloatingHeader
          RightComponent={SearchComponent}
          isMunicipalityHome={isMunicipalityHome}
          municipioQuerySuffix={municipioQuerySuffix}
        />

        <div className="xvia-catalog-header__left-side">
          <div className="xvia-catalog-header__image-wrapper">
            <a
              href={process.env.PORTAL_URL || "/"}
              aria-label="Ir para o portal do Governo do Estado do Piauí"
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/svgs/logo_white_descaracterizada.svg`}
                className="xvia-catalog-header__image"
                alt="Governo do Estado do Piauí"
              />
            </a>
          </div>
          {width > 1063 && <Balances />}
        </div>

        <div>
          <div className="right-side">
            <div className="xvia-catalog-header__links">
              <ul>
                <li>
                  <a
                    href={profileListHref("detran", municipioQuerySuffix)}
                    aria-label="Serviços de transporte e veículos do Detran"
                  >
                    Detran
                  </a>
                </li>
                <li>
                  <a
                    href={profileListHref("cidadao", municipioQuerySuffix)}
                    aria-label="Serviços ao cidadão"
                  >
                    Cidadão
                  </a>
                </li>
                <li>
                  <a
                    href={profileListHref("servidor", municipioQuerySuffix)}
                    aria-label="Serviços para servidor público"
                  >
                    Servidor
                  </a>
                </li>
                <li>
                  <a
                    href={profileListHref("empresa", municipioQuerySuffix)}
                    aria-label="Serviços para empresas"
                  >
                    Empresa
                  </a>
                </li>
                <li>
                  <a
                    href="/app/app-suporte-de-ocorrencia-sisforms"
                    aria-label="Suporte de ocorrência"
                  >
                    Suporte
                  </a>
                </li>
                <li>
                  <a
                    href={profileListHref("municipios", municipioQuerySuffix)}
                    aria-label="Serviços para municípios"
                  >
                    Municípios
                  </a>
                </li>
              </ul>
            </div>
            <div className="xvia-catalog-header__elements">
              <LoginComponent />
            </div>
          </div>
        </div>
      </div>
      {width <= 1063 && (
        <div className="balance-mobile">
          <Balances />
        </div>
      )}
    </div>
  );
};
